export default __webpack_public_path__ + "static/media/kit.ee950694.png";